// ThemeApply.jsx
import { useEffect, useState } from 'react';
import { applySemanticTheme, semanticThemes } from './SemanticColors';

const ThemeApply = () => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [showToast, setShowToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const themeNames = Object.keys(semanticThemes);
    
    // Theme display names with emojis - UPDATED
    const themeDisplayNames = {
        'TealWhiteGrey': '🎨 Teal White Grey',
        'SageGreen': '🌿 Sage Green',
        'DarkMode': '🌙 Dark Mode'
    };

    useEffect(() => {
        const savedTheme = localStorage.getItem('semanticTheme') || 'TealWhiteGrey'; // CHANGED
        const savedIndex = themeNames.indexOf(savedTheme);
        if (savedIndex !== -1) {
            setCurrentIndex(savedIndex);
        }
    }, [themeNames]);

    useEffect(() => {
        const handleKeyDown = (e) => {
            // Check for Alt + T
            if (e.altKey && e.key.toLowerCase() === 't') {
                e.preventDefault();

                // Step 1: Disable BlockerZ first
                const disableEvent = new Event('disableBlockerZ');
                window.dispatchEvent(disableEvent);

                // Step 2: Cycle through themes
                setTimeout(() => {
                    const nextIndex = (currentIndex + 1) % themeNames.length;
                    const nextTheme = themeNames[nextIndex];
                    
                    setCurrentIndex(nextIndex);
                    applySemanticTheme(nextTheme);

                    // Show toast notification with display name
                    const displayName = themeDisplayNames[nextTheme] || nextTheme;
                    setToastMessage(displayName);
                    setShowToast(true);
                    
                    // Hide toast after 2 seconds
                    setTimeout(() => setShowToast(false), 2000);

                    console.log(`✅ Theme switched to: ${nextTheme}`);
                }, 100);
            }
        };

        window.addEventListener('keydown', handleKeyDown);

        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [currentIndex, themeNames, themeDisplayNames]);

    return (
        <>
            {showToast && (
                <div style={{
                    position: 'fixed',
                    top: '24px',
                    right: '24px',
                    backgroundColor: 'var(--MenuBackground)',
                    color: 'var(--MenuBackgroundTextActive)',
                    padding: '16px 24px',
                    borderRadius: '12px',
                    boxShadow: '0 8px 24px rgba(0,0,0,0.3)',
                    zIndex: 10000,
                    fontSize: '15px',
                    fontWeight: '600',
                    animation: 'slideIn 0.3s cubic-bezier(0.68, -0.55, 0.265, 1.55)',
                    border: '2px solid var(--BarBorderDropdown)',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    backdropFilter: 'blur(10px)',
                }}>
                    <span style={{ fontSize: '20px' }}>✨</span>
                    {toastMessage}
                </div>
            )}
            <style>{`
                @keyframes slideIn {
                    from {
                        transform: translateX(400px) scale(0.8);
                        opacity: 0;
                    }
                    to {
                        transform: translateX(0) scale(1);
                        opacity: 1;
                    }
                }
            `}</style>
        </>
    );
};

export default ThemeApply;
